import React from 'react';
import { Button, Space } from 'antd';
import {
  VideoCameraOutlined,
  AudioOutlined,
  AudioMutedOutlined,
  VideoCameraOutlined as VideoCameraOffOutlined,
  CloseOutlined,
  FullscreenOutlined,
  FullscreenExitOutlined,
  SettingOutlined,
  FileTextOutlined,
  BugOutlined
} from '@ant-design/icons';
import { useTranslation } from '../../hooks/useTranslation';

interface CallControlsProps {
  isInCall: boolean;
  isAudioMuted: boolean;
  isVideoOff: boolean;
  isFullscreen: boolean;
  showCaseNotes: boolean;
  onToggleAudio: () => void;
  onToggleVideo: () => void;
  onEndCall: () => void;
  onToggleFullscreen: () => void;
  onToggleCaseNotes: () => void;
  onOpenSettings: () => void;
  onToggleDebug: () => void;
}

const CallControls: React.FC<CallControlsProps> = ({
  isInCall,
  isAudioMuted,
  isVideoOff,
  isFullscreen,
  showCaseNotes,
  onToggleAudio,
  onToggleVideo,
  onEndCall,
  onToggleFullscreen,
  onToggleCaseNotes,
  onOpenSettings,
  onToggleDebug,
}) => {
  const { t } = useTranslation();

  return (
    <div style={{
      padding: '24px',
      backgroundColor: 'rgba(0,0,0,0.9)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexShrink: 0
    }}>
      <Space size="large">
        {/* Audio Control */}
        <Button
          type="text"
          icon={isAudioMuted ? <AudioMutedOutlined /> : <AudioOutlined />}
          onClick={onToggleAudio}
          disabled={!isInCall}
          style={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            backgroundColor: isAudioMuted ? '#ff4d4f' : '#1890ff',
            color: 'white',
            border: 'none'
          }}
        />

        {/* Video Control */}
        <Button
          type="text"
          icon={isVideoOff ? <VideoCameraOffOutlined /> : <VideoCameraOutlined />}
          onClick={onToggleVideo}
          disabled={!isInCall}
          style={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            backgroundColor: isVideoOff ? '#ff4d4f' : '#1890ff',
            color: 'white',
            border: 'none'
          }}
        />

        {/* End Call */}
        <Button
          type="text"
          icon={<CloseOutlined />}
          onClick={onEndCall}
          style={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            backgroundColor: '#ff4d4f',
            color: 'white',
            border: 'none'
          }}
        />

        {/* Fullscreen */}
        <Button
          type="text"
          icon={isFullscreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
          onClick={onToggleFullscreen}
          style={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            backgroundColor: '#1890ff',
            color: 'white',
            border: 'none'
          }}
        />

        {/* Case Notes */}
        <Button
          type="text"
          icon={<FileTextOutlined />}
          onClick={onToggleCaseNotes}
          style={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            backgroundColor: showCaseNotes ? '#52c41a' : '#1890ff',
            color: 'white',
            border: 'none'
          }}
        />

        {/* Settings */}
        <Button
          type="text"
          icon={<SettingOutlined />}
          onClick={onOpenSettings}
          style={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            backgroundColor: '#1890ff',
            color: 'white',
            border: 'none'
          }}
        />


        {/* Debug */} {
          process.env.NODE_ENV === 'development' && (
            <Button
              type="text"
              icon={<BugOutlined />}
              onClick={onToggleDebug}
              style={{
                width: 56,
                height: 56,
                borderRadius: '50%',
                backgroundColor: '#1890ff',
                color: 'white',
                border: 'none'
              }}
            />
          )
        }
      </Space>
    </div>
  );
};

export default CallControls;
